import { render } from "./Main.vue?vue&type=template&id=3ca42fa8"
const script = {}

import exportComponent from "/var/www/kosamba-new-moover/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__